import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './App.scss';
import './CustomStyle.scss'
import * as serviceWorker from './serviceWorker';
import { LicenseManager } from "ag-grid-enterprise";
import './styles/AgGridCustom.css';
import './components/nglteamdailyreport/component/ngl-team-daily-report-component.scss';

LicenseManager.setLicenseKey("PLAINS_MIDSTREAM_CANADA_MultiApp_3Devs28_August_2020__MTU5ODU2OTIwMDAwMA==948ec643f4cdd2ced22be0484b45fa0c");
ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();